import {NAVIGATE} from '/redux/action/navigation.action';
import {
  currentScreen,
  currentScreenParams,
} from '/redux/selector/navigation.selector';
import {getAnalyticsUtilDefaultInstance} from '/util/analytics/analytics.util';

export default ({getState}: any) =>
  (next: any) =>
  (action: any) => {
    const {type: actionType} = action;

    return Promise.resolve(next(action)).then(() => {
      if (actionType === NAVIGATE) {
        const newState = getState();

        getAnalyticsUtilDefaultInstance().trackScreenName({
          screenName: currentScreen(newState),
          screenParams: currentScreenParams(newState),
        });
      }
    });
  };
